// Windows Ready Handler
(function ($) {
	$(document).ready(function () {

		const hash = window.location.hash;

		if (hash) {
			console.log(hash);
			const targetElement = $(hash);

			if (targetElement.length) {
				console.log(targetElement);
				
				$('html, body').scrollTop(0);
				
				$('html, body').animate({
					scrollTop: targetElement.offset().top - $(".site-header").height(),	
				}, 800)

				
			}
		}
	});
})(jQuery);
